import { z } from 'zod';
import { messageKey } from './messages.js';
/**
 * Слаг организации: попадает в URL и в имена потоков go2rtc (фаза 7),
 * поэтому только строчные латинские буквы, цифры и дефис.
 */
export const orgSlugSchema = z
    .string()
    .trim()
    .toLowerCase()
    .pipe(z
    .string()
    .min(2)
    .max(48)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, messageKey('validation.organization.slug')));
export const organizationSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    slug: z.string(),
    createdAt: z.iso.datetime(),
});
export const createOrganizationSchema = z.object({
    name: z.string().trim().min(1).max(200),
    slug: orgSlugSchema,
});
export const updateOrganizationSchema = z
    .object({
    name: z.string().trim().min(1).max(200),
})
    // Слаг неизменяем: он уже разошёлся по ссылкам и именам потоков.
    .partial();
//# sourceMappingURL=organizations.js.map